// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-StudyList-StudyTags-module__removeButton";
var _2 = "webpack-concepts-Extraction-StudyList-StudyTags-module__tag";
var _3 = "webpack-concepts-Extraction-StudyList-StudyTags-module__tagIcon";
var _4 = "webpack-concepts-Extraction-StudyList-StudyTags-module__tags";
var _5 = "webpack-concepts-Extraction-StudyList-StudyTags-module__tagsContainer";
export { _1 as "removeButton", _2 as "tag", _3 as "tagIcon", _4 as "tags", _5 as "tagsContainer" }
